<p-blockUI [blocked]="isBlocked">
  <p-progressSpinner
    strokeWidth="4"
    [style]="{ width: '6rem', height: '6rem' }"
    styleClass="progress-spinner center-screen"
  ></p-progressSpinner>
</p-blockUI>
